var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";
import Stack from "syf-component-library/ui/spacing/Stack";
import EditProfileContent from "./EditProfileContent";
import updateProfileDetails from "./helpers";
import { PAGE_NAME, PAGE_SUBFUNCTION } from "../../../const/analytics";
import { useAccountSummary, useCreditAccounts, useMultiProfileUpdate, useProfile, } from "../../../const/syfApiQueries";
import EditProfileContextProvider from "../../../context/editProfileContext";
import { useProfileGlobalState } from "../../../context/profileGlobalState";
import checkFailingMutations from "../../../helpers/checkFailingMutations";
import getFieldErrorMessages from "../../../helpers/getFieldErrorMessages";
import getProfilePayload from "../../../helpers/getProfilePayload";
import containsErrorString from "../../../helpers/handleBusinessErrors";
import triggerProfileAnalytics from "../../../helpers/triggerProfileAnalytics";
import updateFormValues from "../../../helpers/updateFormValues";
import { useConfig } from "../../../hooks/useConfig";
import useCurrentAccount from "../../../hooks/useCurrentAccounts";
import useIsTablet from "../../../hooks/useIsTablet";
import useScrollToTop from "../../../hooks/useScrollToTop";
import { InnerContentWrapper } from "../../subcomponents";
import { PROFILE_UPDATE_PAYLOAD_SCHEMA } from "../../../schemas/profile.schema";
import { parseOrLog } from "../../../schemas/utils/parseOrLog";
var EditProfile = function () {
    var _a;
    useScrollToTop();
    var profileConfig = useConfig();
    var _b = useProfileGlobalState(), selectedAccountId = _b.state.selectedAccountId, dispatch = _b.dispatch, goToShowProfile = _b.goToShowProfile;
    var accounts = useCurrentAccount(selectedAccountId);
    var selectedAccount = accounts.selectedAccount, selectedAccountOption = accounts.selectedAccountOption;
    var accountsQuery = useCreditAccounts(profileConfig).data;
    var accountsList = (accountsQuery === null || accountsQuery === void 0 ? void 0 : accountsQuery.accounts) || [];
    var selectedAccountSummary = useAccountSummary(selectedAccountOption.value, profileConfig).data;
    var profileQuery = useProfile(selectedAccountOption.value, profileConfig);
    var data = profileQuery.data;
    var prevAccountRef = useRef(data);
    var prevAccount = prevAccountRef.current;
    var mutateAsync = useMultiProfileUpdate(profileConfig, (_a = selectedAccount === null || selectedAccount === void 0 ? void 0 : selectedAccount.info) === null || _a === void 0 ? void 0 : _a["cipher.accountId"]).mutateAsync;
    var _c = useState([]), fieldErrorStrings = _c[0], setFieldErrorStrings = _c[1];
    var _d = useState([selectedAccountId]), selectedAccounts = _d[0], setSelectedAccounts = _d[1];
    var _e = useState(undefined), pageApiError = _e[0], setPageApiError = _e[1];
    var _f = useState([]), accountsWithErrors = _f[0], setAccountsWithErrors = _f[1];
    var _g = useState(false), alertsError = _g[0], setAlertsError = _g[1];
    var isTablet = useIsTablet();
    var _h = useFormContext(), dirtyFields = _h.formState.dirtyFields, handleSubmit = _h.handleSubmit, setValue = _h.setValue, clearErrors = _h.clearErrors, reset = _h.reset, watch = _h.watch;
    var handleAddressSelectChange = useCallback(function (name, value) {
        setValue(name, value, {
            shouldDirty: true,
            shouldTouch: true,
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var watchPhoneInputs = watch([
        "phoneNumbers.business",
        "phoneNumbers.home",
        "phoneNumbers.mobile",
    ]);
    var updateSelectedAccounts = useCallback(function (newSelectedAccounts) {
        setSelectedAccounts(newSelectedAccounts);
    }, []);
    var updateAccountsWithErrors = useCallback(function (newAccountsWithErrors) {
        setAccountsWithErrors(newAccountsWithErrors);
    }, []);
    var updateFieldErrorStrings = useCallback(function (newFieldErrorStrings) {
        setFieldErrorStrings(newFieldErrorStrings);
    }, []);
    var onSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var profilePayload, _a, rejectedMutations, businessErrorsMatrix, invalidFieldErrors, failingAccounts, mutatedAccountsWithErrors, newSelectedAccounts, accountsMutationErrors, fieldErrors, containsString;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setFieldErrorStrings([]);
                    clearErrors();
                    profilePayload = getProfilePayload({ formData: formData, dirtyFields: dirtyFields });
                    parseOrLog(PROFILE_UPDATE_PAYLOAD_SCHEMA, profilePayload, "[Profile update cleaned payload]");
                    return [4 /*yield*/, updateProfileDetails({
                            selectedAccount: selectedAccount,
                            selectedAccounts: selectedAccounts,
                            profilePayload: profilePayload,
                            mutateAsync: mutateAsync,
                        })];
                case 1:
                    _a = _b.sent(), rejectedMutations = _a.rejectedMutations, businessErrorsMatrix = _a.businessErrorsMatrix, invalidFieldErrors = _a.invalidFieldErrors;
                    if (rejectedMutations.length === 0) {
                        goToShowProfile();
                        dispatch({ didEditMutationSucceeded: true });
                    }
                    else {
                        failingAccounts = checkFailingMutations(selectedAccounts, rejectedMutations, invalidFieldErrors);
                        mutatedAccountsWithErrors = failingAccounts.mutatedAccountsWithErrors, newSelectedAccounts = failingAccounts.newSelectedAccounts, accountsMutationErrors = failingAccounts.accountsMutationErrors, fieldErrors = failingAccounts.fieldErrors;
                        if (fieldErrors !== undefined) {
                            setFieldErrorStrings(getFieldErrorMessages(fieldErrors));
                        }
                        if (businessErrorsMatrix && (businessErrorsMatrix === null || businessErrorsMatrix === void 0 ? void 0 : businessErrorsMatrix.length) > 0) {
                            containsString = containsErrorString(businessErrorsMatrix);
                            if (containsString) {
                                setAlertsError(true);
                            }
                        }
                        updateAccountsWithErrors(mutatedAccountsWithErrors);
                        updateSelectedAccounts(newSelectedAccounts);
                        setPageApiError(accountsMutationErrors);
                        triggerProfileAnalytics({
                            pageName: PAGE_NAME.EDIT_PROFILE,
                            pageSubFunction: PAGE_SUBFUNCTION.ERROR,
                            errorMessage: accountsMutationErrors,
                        });
                        window.scrollTo(0, 0);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        prevAccountRef.current = data;
    }, [data]);
    useEffect(function () {
        if (!!data && prevAccount !== data) {
            var updatedFormValues = updateFormValues(data);
            reset(updatedFormValues);
        }
    }, [data, reset, prevAccount]);
    useEffect(function () {
        updateSelectedAccounts([selectedAccountOption.value]);
    }, [selectedAccountOption.value, updateSelectedAccounts]);
    useEffect(function () {
        triggerProfileAnalytics({
            pageName: PAGE_NAME.EDIT_PROFILE,
        });
    }, []);
    return (_jsx(EditProfileContextProvider, __assign({ state: {
            selectedAccountOption: selectedAccountOption,
            selectedAccountSummary: selectedAccountSummary,
            isTablet: isTablet,
            data: data,
            pageApiError: pageApiError,
            fieldErrorStrings: fieldErrorStrings,
            alertsError: alertsError,
            phoneRequiredError: !watchPhoneInputs.some(Boolean),
            handleAddressSelectChange: handleAddressSelectChange,
            accountsList: accountsList,
            selectedAccounts: selectedAccounts,
            updateSelectedAccounts: updateSelectedAccounts,
            accountsWithErrors: accountsWithErrors,
            updateAccountsWithErrors: updateAccountsWithErrors,
            updateFieldErrorStrings: updateFieldErrorStrings,
        } }, { children: _jsx(InnerContentWrapper, { children: _jsxs("form", __assign({ onSubmit: handleSubmit(onSubmit) }, { children: [_jsx(Stack, { size: "small" }), _jsx(EditProfileContent, {})] })) }) })));
};
export default EditProfile;
